import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrFactSheetHeaderComponent } from './kn-br-fact-sheet-header.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrFactSheetHeaderComponent: {
                    component: () => import('./kn-br-fact-sheet-header.component').then((c) => c.KnBrFactSheetHeaderComponent),
                },
            },
        } as CmsConfig),
        KnBrFactSheetHeaderComponent,
    ],
})
export class KnBrFactSheetHeaderModule {}
